export default "__VITE_ASSET__Cbi88pEU__"